import React from 'react';
import styles from './SkeletonPost.module.css';

const SkeletonPost: React.FC = () => {
  return (
    <div className={styles.skeletonPost}>
      <div className={styles.skeletonHeader}>
        <div className={styles.skeletonAvatar}></div>
        <div className={styles.skeletonUserInfo}>
          <div className={styles.skeletonUserName}></div>
          <div className={styles.skeletonDate}></div>
        </div>
      </div>

      <div className={styles.skeletonContent}>
        <div className={styles.skeletonTextLine} style={{ width: '100%' }}></div>
        <div className={styles.skeletonTextLine} style={{ width: '85%' }}></div>
        <div className={styles.skeletonTextLine} style={{ width: '70%' }}></div>
      </div>

      <div className={styles.skeletonImage}>
        <div className={styles.skeletonImageContent}></div>
      </div>

      <hr className={styles.skeletonDivider} />

      <div className={styles.skeletonActions}>
        <div className={styles.skeletonActionButton}></div>
        <div className={styles.skeletonActionButton}></div>
        <div className={styles.skeletonActionButton}></div>
      </div>
    </div>
  );
};

export default SkeletonPost;
